import IcAlertVF from './IcAlertVF'
export default IcAlertVF
